import "bootstrap";
import "bootstrap/scss/bootstrap.scss";
import { createApp, version } from "vue";
import AppComponent from "./app.component.vue";
import router from "./router";
import store from "./store";
import acl from "./acl";
import axios from "axios";
import VueAxios from "vue-axios";
//import vuescroll from "vuescroll/dist/vuescroll-native";
import { vue3Debounce } from 'vue-debounce'
import { initializeApp } from "firebase/app";
import { firebaseSettings } from "./settings/firebase";
import "vue-select/dist/vue-select.css";

initializeApp(firebaseSettings.firebaseConfig);

createApp(AppComponent)
  .use(store)
  .use(router)
  .use(acl)
  .use(VueAxios, axios)
  .directive('debounce', vue3Debounce({ lock: true }))
  .mount("#app");
